/* assets/dvy-fit-fabric.js */
(function () {
  'use strict';

  const FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';

  class DvySizeGuide extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-guide-open]');
      this.modal = this.querySelector('[data-guide-modal]');
      this.panel = this.querySelector('.dvy-ff__modal-panel');
      if (!this.trigger || !this.modal || !this.panel) return;

      this.onOpen = this.open.bind(this);
      this.onClose = this.close.bind(this);
      this.onKeydown = this.handleKeydown.bind(this);

      this.trigger.addEventListener('click', this.onOpen);
      this.querySelectorAll('[data-guide-close]').forEach((el) =>
        el.addEventListener('click', this.onClose)
      );
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeydown);
      document.body.classList.remove('dvy-ff-locked');
    }

    open(event) {
      if (event) event.preventDefault();
      this.lastFocused = document.activeElement;
      this.modal.hidden = false;
      document.body.classList.add('dvy-ff-locked');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('keydown', this.onKeydown);
      requestAnimationFrame(() => this.panel.focus());
    }

    close(event) {
      if (event) event.preventDefault();
      this.modal.hidden = true;
      document.body.classList.remove('dvy-ff-locked');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', this.onKeydown);
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') {
        this.lastFocused.focus();
      }
    }

    handleKeydown(event) {
      if (event.key === 'Escape') {
        this.close();
        return;
      }
      if (event.key !== 'Tab') return;

      const nodes = Array.from(this.panel.querySelectorAll(FOCUSABLE)).filter(
        (el) => el.offsetParent !== null
      );
      if (!nodes.length) {
        event.preventDefault();
        this.panel.focus();
        return;
      }
      const first = nodes[0];
      const last = nodes[nodes.length - 1];

      if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('dvy-size-guide')) {
    customElements.define('dvy-size-guide', DvySizeGuide);
  }

  // Theme editor: close any open modal when the section reloads
  document.addEventListener('shopify:section:unload', function () {
    document.body.classList.remove('dvy-ff-locked');
  });
})();